import CrudRepository from './CrudRepository'

export default class StatisticsRepository extends CrudRepository {
  constructor () {
    super('statistics')
  }
}
